import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hiddenField"]

  declare readonly hiddenFieldTargets: HTMLInputElement[]

  sync(event: Event) {
    const input = event.currentTarget as HTMLInputElement | HTMLSelectElement
    const fieldName = this.getFieldName(input)

    if (fieldName) {
      const hiddenField = this.hiddenFieldTargets.find(
        (target) => this.getFieldName(target) === fieldName,
      )

      if (hiddenField) {
        if (input instanceof HTMLInputElement && input.type === "checkbox") {
          hiddenField.value = input.checked ? "1" : "0"
        } else {
          hiddenField.value = input.value
        }
      }
    }
  }

  private getFieldName(
    element: HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement,
  ): string | null {
    const dataFieldName = element.getAttribute("data-field-name")
    if (dataFieldName) return dataFieldName

    const nameMatch = element.name.match(/\[(\w+)\]$/)
    if (nameMatch) return nameMatch[1]

    const idMatch = element.id.match(/book_(\w+)$/)
    if (idMatch) return idMatch[1]

    return null
  }
}
